import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportGenerateRequest, ReportGenerateResponse } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(private api: ApiService) {}

  generateReport(request: ReportGenerateRequest): Observable<ReportGenerateResponse> {
    return this.api.post<ReportGenerateResponse>('/api/reports/generate', request);
  }

  downloadReport(request: ReportGenerateRequest): Observable<Blob> {
    return this.api.postBlob('/api/reports/generate', { ...request, download: true });
  }
}
